<template>

  <div class="product-details">
    <ul class="details-list" v-if="details.length > 0">
      <li class="details-list-elem"
          v-for="(item, index) in details"
          :key="index"
      >
        {{ item.featureInt }},
      </li>
    </ul>
  </div>

</template>

<script>

    export default {
        name: "ProductViewDetails",
        props: {
            details: Array
        }
    }
</script>

<style lang="scss" scoped>

.product-details {
  margin-bottom: 30px;

  .details-list {
    /*padding-left: 18px;*/
    font-size: 14px;
    line-height: 22px;
  }

  .details-list-elem {
    /*list-style-type: disc;*/
    display: inline-block;
    padding-right: 3px;
  }
}

</style>